import {Products} from "@/app/enums/Products";

type Links = {
    text: string
    url: string
}

interface IProductsLinks {
    [key: string]: {
        [category: string]: Links[]
    }
}

const PATHS_TO_PRODUCT = {
    [Products.LOAN]: [
        '/guide/pret-immobilier',
        '/taux-pret-immobilier',
    ],
    [Products.LOAN_INSURANCE]: [
        '/guide/assurance-pret-immobilier',
        '/simulation-assurance-pret-immobilier',
    ],
    [Products.HEALTH]: [
        '/comparateur-mutuelle-sante',
        '/mutuelle-sante/client-courtage',
        '/guide/mutuelle-sante',
        '/guide/surcomplementaire-sante',
        '/guide/assurance-hospitalisation',
    ],
    [Products.HEALTH_COMPARATOR]: [
        '/devis-mutuelle-sante',
    ],
    [Products.TRAVEL]: [
        '/guide/assurance-voyage',
    ],
    [Products.DOG_CAT]: [
        '/guide/assurance-chien-chat',
    ],
    [Products.DEATH_INSURANCE]: [
        '/guide/prevoyance',
        '/guide/assurance-deces',
        '/guide/assurance-dependance',
        '/guide/assurance-obseques',
        '/guide/pro/prevoyance',
        '/guide/assurance-garantie-accidents-vie',
    ],
}

const PRODUCTS_LINKS: IProductsLinks = {
    [Products.LOAN]: {
        "Les indispensables": [
            {text: "Taux de prêt immobilier", url: "/taux-pret-immobilier"},
            {text: "Prêt immobilier sans intérêt", url: "/guide/pret-immobilier/sans-interets"},
            {text: "Prêt immobilier avec apport", url: "/guide/pret-immobilier/apport"},
            {text: "Tableau d'amortissement", url: "/guide/pret-immobilier/tableau-amortissement"},
            {text: "Délais d'acceptation", url: "/guide/pret-immobilier/delai-acceptation"},
            {text: "Prévision taux immobilier", url: "/guide/pret-immobilier/previsions-taux-immobilier"},
            {text: "Déblocage de fonds chez le notaire", url: "/guide/pret-immobilier/appel-fonds-notaire"},
            {text: "Délais d'offre de prêt immobilier", url: "/guide/pret-immobilier/delai-offre"},
            {text: "Prêt immobilier et divorce", url: "/guide/pret-immobilier/divorce"},
            {text: "Prêt immobilier sans CDI", url: "/guide/pret-immobilier/sans-cdi"},
            {text: "Augmenter ses mensualités", url: "/guide/pret-immobilier/augmenter-mensualites"},
            {text: "Prêt immobilier avec travaux", url: "/guide/pret-immobilier/avec-travaux"}
        ],
        "Nos simulateurs": [
            {text: "Simulation de prêt immobilier", url: "/guide/pret-immobilier/simulation"},
            {text: "Annuité d’emprunt", url: "/guide/pret-immobilier/annuite-emprunt"},
            {text: "Rachat de prêt immobilier", url: "/guide/pret-immobilier/rachat"},
            {text: "Calcul des frais de notaires", url: "/guide/pret-immobilier/calcul-frais-notaire"},
            {text: "Capacité d'emprunt", url: "/guide/pret-immobilier/capacite-emprunt"},
            {text: "Reste à vivre", url: "/guide/pret-immobilier/reste-a-vivre"},
            {text: "Renégocier un prêt", url: "/guide/pret-immobilier/renegocier"},
            {text: "Simulation PTZ", url: "/guide/pret-immobilier/simulation-ptz"},
            {text: "Taux d'endettement", url: "/guide/pret-immobilier/calcul-taux-endettement"},
            {text: "Capital restant dû", url: "/guide/pret-immobilier/capital-restant-du"},
            {text: "Calcul de mensualités", url: "/guide/pret-immobilier/calcul-mensualites"}
        ],
        "Guide de l'emprunteur": [
            {text: "Prêt immobilier", url: "/guide/pret-immobilier"},
            {text: "Prêt immobilier pour étudiant", url: "/guide/pret-immobilier/etudiant"},
            {text: "Refus de prêt immobilier", url: "/guide/pret-immobilier/refus"},
            {text: "Suspendre un prêt immobilier", url: "/guide/pret-immobilier/suspendre"},
            {text: "Transférer un prêt immobilier", url: "/guide/pret-immobilier/transfert"},
            {text: "Désolidariser d’un crédit immobilier", url: "/guide/pret-immobilier/desolidariser"},
            {text: "Remboursement anticipé de prêt immobilier", url: "/guide/pret-immobilier/remboursement-anticipe"},
            {text: "Prêt à Taux Zéro", url: "/guide/pret-immobilier/pret-taux-zero"},
            {text: "Prêt TAEG", url: "/guide/pret-immobilier/taeg"},
            {text: "Prêt relais", url: "/guide/pret-immobilier/pret-relais"}
        ]
    },
    [Products.LOAN_INSURANCE]: {
        "Les indispensables": [
            {text: "Résilier une assurance emprunteur", url: "/guide/assurance-pret-immobilier/resilier"},
            {
                text: "Quand renégocier une assurance de prêt ?",
                url: "/guide/assurance-pret-immobilier/renegocier"
            },
            {text: "Garanties emprunteur", url: "/guide/assurance-pret-immobilier/garanties"},
            {text: "Les lois", url: "/guide/assurance-pret-immobilier/lois"},
            {text: "Délégation d’assurance emprunteur", url: "/guide/assurance-pret-immobilier/delegation"},
            {text: "Loi Lemoine", url: "/guide/assurance-pret-immobilier/loi-lemoine"},
            {text: "Invalidité et assurance emprunteur", url: "/guide/assurance-pret-immobilier/taux-invalidite"},
            {text: "Remboursement anticipé d'une assurance", url: "/guide/assurance-pret-immobilier/remboursement-anticipe"}
        ],
        "Assurer son crédit immobilier": [
            {
                text: "Comparateur assurance de prêt immobilier",
                url: "/simulation-assurance-pret-immobilier"
            },
            {text: "Coût d'une assurance de prêt immobilier", url: "/guide/assurance-pret-immobilier/calcul"},
            {text: "Taux d’assurance de prêt immobilier", url: "/guide/assurance-pret-immobilier/taux"},
            {text: "Meilleure assurance emprunteur", url: "/guide/assurance-pret-immobilier/meilleure"},
            {text: "Assurance emprunteur et sports à risque", url: "/guide/assurance-pret-immobilier/sport-risque"},
            {text: "Assurance emprunteur et risques aggravés", url: "/guide/assurance-pret-immobilier/risque-aggrave"},
            {text: "Assurance emprunteur et métiers à risques", url: "/guide/assurance-pret-immobilier/metier-risques"},
            {text: "Assurance pour un prêt professionnel", url: "/guide/assurance-pret-immobilier/professionnel"}
        ],
        "Guide de l'assurance de prêt": [
            {text: "Fonctionnement assurance emprunteur", url: "/guide/assurance-pret-immobilier"},
            {text: "Questionnaire santé de l’assurance prêt immobilier", url: "/guide/assurance-pret-immobilier/questionnaire-sante"},
            {text: "TAEA : qu'est-ce que c'est ?", url: "/guide/assurance-pret-immobilier/taea"},
            {text: "Refus assurance pret immobilier", url: "/guide/assurance-pret-immobilier/refus-banque"},
            {text: "Coût d'une assurance pret immobilier", url: "/guide/assurance-pret-immobilier/cout"},
            {text: "Quotité d'assurance", url: "/guide/assurance-pret-immobilier/quotite"},
            {
                text: "Pourquoi changer d'assurance emprunteur ?",
                url: "/guide/assurance-pret-immobilier/changer"
            },
            {text: "Remboursement d'un prêt immobilier", url: "/guide/assurance-pret-immobilier/remboursement-anticipe"}
        ]
    },
    [Products.HEALTH]: {
        "Les indispensables": [
            {text: "Comparateur mutuelle santé", url: "/comparateur-mutuelle-sante"},
            {text: "Devis mutuelle santé", url: "/devis-mutuelle-sante"},
            {text: "Meilleure mutuelle santé", url: "/guide/mutuelle-sante/meilleure"},
            {text: "Prix d'une mutuelle santé", url: "/guide/mutuelle-sante/tarif"},
            {text: "Résilier une mutuelle santé", url: "/guide/mutuelle-sante/resilier"},
            {text: "Mutuelle santé pas chère", url: "/guide/mutuelle-sante/pas-cher"},
            {text: "Mutuelle santé expatrié USA", url: "/guide/mutuelle-sante/expatries/expatrie-usa"},
            {text: "Le reste à charge zéro", url: "/guide/mutuelle-sante/reste-a-charge-zero"},
            {text: "Bilan de santé", url: "/guide/mutuelle-sante/bilan-sante"}
        ],
        "Votre profil": [
            {text: "Mutuelle santé senior", url: "/guide/mutuelle-sante/senior"},
            {text: "Mutuelle santé familiale", url: "/guide/mutuelle-sante/famille"},
            {text: "Mutuelle santé pour étudiant", url: "/guide/mutuelle-sante/mutuelle-etudiante"},
            {text: "Mutuelle santé pour fonctionnaire", url: "/guide/mutuelle-sante/fonctionnaires"},
            {text: "Mutuelle santé pour jeune", url: "/guide/mutuelle-sante/jeunes"},
            {text: "Mutuelle santé dentaire", url: "/guide/mutuelle-sante/mutuelle-dentaire"},
            {text: "Mutuelle santé orthodontie", url: "/guide/mutuelle-sante/mutuelle-orthodontie-adulte"},
            {text: "Mutuelle santé optique", url: "/guide/mutuelle-sante/mutuelle-optique"},
            {text: "Mutuelle santé expatrié", url: "/guide/mutuelle-sante/expatries"},
            {text: "Mutuelle TNS", url: "/guide/pro/tns"},
            {text: "Client courtage réassurez-moi", url: "/mutuelle-sante/client-courtage"}
        ],
        "Nos guides": [
            {text: "Modèles de lettre de la mutuelle santé", url: "/guide/mutuelle-sante/modele"},
            {text: "Changer de mutuelle santé", url: "/guide/mutuelle-sante/changer"},
            {text: "Renégocier sa mutuelle santé", url: "/guide/mutuelle-sante/renegocier"},
            {text: "Remboursement d'une mutuelle santé", url: "/guide/mutuelle-sante/remboursement"},
            {text: "Assureurs de mutuelles santé", url: "/guide/mutuelle-sante/assureurs"},
            {text: "Surcomplémentaire santé", url: "/guide/surcomplementaire-sante"}
        ]
    },
    [Products.TRAVEL]: {
        "Les indispensables": [
            {text: "Assurance rapatriement", url: "/guide/assurance-voyage/rapatriement"},
            {text: "Assurance annulation voyage", url: "/guide/assurance-voyage/annulation-voyage"},
            {text: "Assurance voyage à l'étranger", url: "/guide/assurance-voyage"},
            {text: "Assurance bagage", url: "/guide/assurance-voyage/bagages"},
            {text: "Assurance annulation billet d'avion", url: "/guide/assurance-voyage/annulation-vol"},
        ],
        "Destinations": [
            {text: "Assurance voyage Etats-Unis / USA", url: "/guide/assurance-voyage/usa"},
            {text: "Assurance voyage Canada", url: "/guide/assurance-voyage/canada"},
            {text: "Assurance voyage Schengen", url: "/guide/assurance-voyage/schengen"},
            {text: "Assurance voyage Japon", url: "/guide/assurance-voyage/japon"},
            {text: "Assurance voyage Australie", url: "/guide/assurance-voyage/australie"},
            {text: "Assurance voyage Asie", url: "/guide/assurance-voyage/asie"},
        ],
        "Besoins spécifiques": [
            {text: "Assurance PVT", url: "/guide/assurance-voyage/pvt"},
            {text: "Assurance expatrié", url: "/guide/assurance-voyage/expatrie"},
            {text: "Assurance voyage annuelle", url: "/guide/assurance-voyage/annuelle"},
            {text: "Assurance voyage longue durée", url: "/guide/assurance-voyage/longue-duree"},
            {text: "Assurance étudiant à l'étranger", url: "/guide/assurance-voyage/etudes-etranger"},
            {text: "Assurance voyage femme enceinte", url: "/guide/assurance-voyage/grossesse"},
        ]
    },
    [Products.DOG_CAT]: {
        "Les indispensables": [
            {text: "Comparateur assurance animaux", url: "/guide/assurance-chien-chat"},
            {text: "Prix assurance chien ou chat", url: "/guide/assurance-chien-chat/prix"},
            {text: "Prix consultation vétérinaire", url: "/guide/assurance-chien-chat/frais-veterinaire"},
            {text: "Assurance animaux sans carence", url: "/guide/assurance-chien-chat/assurance-chien/sans-carence"},
            {text: "Assurance NAC", url: "/guide/assurance-chien-chat/nac"},
            {text: "Assureurs de mutuelle pour animaux", url: "/guide/assurance-chien-chat/assureurs"},
        ],
        "Assurer votre chien": [
            {text: "Assurance chien", url: "/guide/assurance-chien-chat/assurance-chien"},
            {text: "Vaccin chien", url: "/guide/assurance-chien-chat/assurance-chien/vaccin-chien"},
            {text: "Prix castration chien", url: "/guide/assurance-chien-chat/assurance-chien/castration-chien"},
            {text: "Prix puce chien", url: "/guide/assurance-chien-chat/assurance-chien/prix-puce-chien"},
            {text: "Assurance chien catégorie 2", url: "/guide/assurance-chien-chat/assurance-chien/chien-categorie-2"},
            {text: "Assurance chien de chasse", url: "/guide/assurance-chien-chat/assurance-chien/chien-chasse"},
        ],
        "Assurer votre chat": [
            {text: "Assurance chat", url: "/guide/assurance-chien-chat/assurance-chat"},
            {text: "Prix vaccin chat", url: "/guide/assurance-chien-chat/assurance-chat/vaccin-chat"},
            {text: "Prix stérilisation chat", url: "/guide/assurance-chien-chat/assurance-chat/sterilisation-chat"},
            {text: "Prix puce chat", url: "/guide/assurance-chien-chat/assurance-chat/prix-identification-chat"},
            {text: "Combien coûte un chat par mois ?", url: "/guide/assurance-chien-chat/assurance-chat/cout-chat-mois"},
            {text: "Assurance chat sans limite d’âge", url: "/guide/assurance-chien-chat/assurance-chat/sans-limite-dage"},
        ]
    },
    [Products.DEATH_INSURANCE]: {
        "Prévoyance": [
            {text: "Assurance famille", url: "/guide/prevoyance/famille"},
            {text: "Prévoyance senior", url: "/guide/prevoyance/senior"},
            {text: "Prévoyance d'entreprise", url: "/guide/pro/prevoyance/comparateur"},
            {text: "Prévoyance TNS", url: "/guide/pro/prevoyance/tns"},
            {text: "Prévoyance profession libérale", url: "/guide/pro/prevoyance/profession-liberale"},
            {text: "Garantie Accident de la Vie - GAV", url: "/guide/assurance-garantie-accidents-vie"}
        ],
        "Assurance Décès": [
            {text: "Assurance décès en ligne", url: "/guide/assurance-deces"},
            {text: "Tarif assurance décès", url: "/guide/assurance-deces/prix"},
            {text: "Résiliation assurance décès", url: "/guide/assurance-deces/resiliation"},
            {text: "Rachat assurance décès", url: "/guide/assurance-deces/rachat"},
            {text: "Capital décès d'un retraité", url: "/guide/assurance-deces/capital-deces"},
            {text: "Assurance rapatriement de corps", url: "/guide/assurance-deces/rapatriement-corps"},
            {text: "Assurance décès avantages et inconvénients", url: "/guide/assurance-deces/souscrire"},
            {text: "Différence assurance vie et assurance décès", url: "/guide/assurance-deces/difference-assurance-vie"}
        ],
        "Assurance Obsèques": [
            {text: "Meilleure assurance obsèques", url: "/guide/assurance-obseques"},
            {text: "Contrat obsèques tarif", url: "/guide/assurance-obseques"},
            {text: "Assurance obsèques âge limite", url: "/guide/assurance-obseques/age-limite"},
            {text: "Contrat obsèques sans délai de carence", url: "/guide/assurance-obseques/delai-carence"},
            {text: "Différence entre assurance décès et assurance obsèques", url: "/guide/assurance-deces/difference-assurance-obseques"},
            {text: "Prix d'une crémation tout compris", url: "/guide/assurance-obseques/frais"},
            {text: "Prix d'une incinération", url: "/guide/assurance-obseques/prix-incineration-cremation"}
        ],
        "Assurance dépendance": [
            {text: "Meilleure assurance dépendance", url: "/guide/assurance-dependance"},
            {text: "Tarif assurance dépendance", url: "/guide/assurance-dependance/tarif"},
            {text: "Maintien à domicile", url: "/guide/assurance-dependance/maintien-domicile"},
            {text: "Assurance perte d'autonomie", url: "/guide/assurance-dependance/perte-autonomie"},
            {text: "Rente dépendance", url: "/guide/assurance-dependance/rente"},
            {text: "Label GAD", url: "/guide/assurance-dependance/label-gad"}
        ]
    },
    [Products.COMMON]: {
        "Assurance emprunteur": [
            {
                text: "Comparateur assurance de prêt immobilier",
                url: "/simulation-assurance-pret-immobilier"
            },
            {text: "Fonctionnement assurance emprunteur", url: "/guide/assurance-pret-immobilier"},
            {text: "Coût d'une assurance de prêt immobilier", url: "/guide/assurance-pret-immobilier/calcul"},
            {text: "Taux d’assurance de prêt immobilier", url: "/guide/assurance-pret-immobilier/taux"},
            {text: "Changer d'assurance emprunteur", url: "/guide/assurance-pret-immobilier/changer"},
            {text: "Garanties emprunteur", url: "/guide/assurance-pret-immobilier/garanties"},
            {text: "Les lois", url: "/guide/assurance-pret-immobilier/lois"},
            {text: "Meilleure assurance emprunteur", url: "/guide/assurance-pret-immobilier/meilleure"},
            {text: "Délégation d’assurance emprunteur", url: "/guide/assurance-pret-immobilier/delegation"}
        ],
        "Outils de simulation de prêt immobilier": [
            {text: "Simulation de prêt immobilier", url: "/guide/pret-immobilier/simulation"},
            {text: "Annuité d’emprunt", url: "/guide/pret-immobilier/annuite-emprunt"},
            {text: "Rachat de prêt immobilier", url: "/guide/pret-immobilier/rachat"},
            {text: "Calcul des frais de notaires", url: "/guide/pret-immobilier/calcul-frais-notaire"},
            {text: "Capacité d'emprunt", url: "/guide/pret-immobilier/capacite-emprunt"},
            {text: "Reste à vivre", url: "/guide/pret-immobilier/reste-a-vivre"},
            {text: "Renégocier un prêt", url: "/guide/pret-immobilier/renegocier"},
            {text: "Simulation PTZ", url: "/guide/pret-immobilier/simulation-ptz"},
            {text: "Taux d'endettement", url: "/guide/pret-immobilier/calcul-taux-endettement"},
            {text: "Capital restant dû", url: "/guide/pret-immobilier/capital-restant-du"}
        ],
        "Mutuelle santé": [
            {text: "Comparateur de mutuelle santé", url: "/comparateur-mutuelle-sante"},
            {text: "Meilleure mutuelle santé", url: "/guide/mutuelle-sante/meilleure"},
            {text: "Calcul Remboursement Mutuelle", url: "/guide/mutuelle-sante/remboursement/simulateur-remboursement-mutuelle"},
            {text: "Devis mutuelle santé", url: "/devis-mutuelle-sante"},
            {text: "Mutuelle santé expatrié", url: "/guide/mutuelle-sante/expatries"},
            {text: "Garanties de mutuelle santé", url: "/guide/mutuelle-sante/garanties"},
            {text: "Mutuelle santé internationale", url: "/guide/mutuelle-sante/expatries"},
            {text: "Mutuelle TNS", url: "/guide/pro/tns"},
            {text: "Mutuelle santé senior", url: "/guide/mutuelle-sante/senior"},
            {text: "Mutuelle santé pas cher", url: "/guide/mutuelle-sante/pas-cher"},
            {text: "Client courtage réassurez-moi", url: "/mutuelle-sante/client-courtage"}
        ],
        "Comparateur Assurance": [
            {text: "Assurance habitation", url: "/guide/assurance-habitation"},
            {text: "Assurance voyage", url: "/guide/assurance-voyage"},
            {text: "Assurance dépendance", url: "/guide/assurance-dependance"},
            {text: "Rachat de crédit", url: "/guide/rachat-credit"},
            {text: "Assurance GAV", url: "/guide/assurance-garantie-accidents-vie"},
            {text: "Assurance décès", url: "/guide/assurance-deces"},
            {text: "Assurance obsèques", url: "/guide/assurance-obseques"},
            {text: "Assurance moto", url: "/guide/assurance-moto"},
            {text: "Assurance auto", url: "/guide/assurance-auto"},
            {text: "Toutes nos autres assurances", url: "/nos-assurances"}
        ]
    }
}

function getContextLinks(pathname: string) {
    for (const [product, paths] of Object.entries(PATHS_TO_PRODUCT)) {
        if (paths.some(path => pathname.startsWith(path))) {
            return PRODUCTS_LINKS[product] || PRODUCTS_LINKS[Products.COMMON]
        }
    }

    return PRODUCTS_LINKS[Products.COMMON]
}

function getProductName(pathname: string) {
    for (const [product, paths] of Object.entries(PATHS_TO_PRODUCT)) {
        if (paths.some(path => pathname.startsWith(path))) {
            return product
        }
    }

    return Products.COMMON
}

export {getContextLinks, getProductName, PATHS_TO_PRODUCT}
